<template>
  <div>
    <div class="post-thumbs-listing listing-rowed items-3-per-row" v-if="localContent && localContent.length <= 3">
      <ul class="list-wrap">
        <li
          class="list-item"
          v-for="(c, index) in localContent"
          :key="index"
        >
          <PostThumbCard
            v-if="c && c.type === 'post'"
            :post="c.entity"
            @post-destroyed="destroyContent"
          />
          <UserProfileCard
            v-if="c && c.type === 'user'"
            :user="c.entity"
          />
          <BookThumbCard
            v-if="c && c.type === 'book'"
            :book="c.entity"
            @book-destroyed="destroyContent"
          />
        </li>
      </ul>
    </div>
    <div class="post-thumbs-carousel posts-thumbs-listing listing-rowed mt-lg-3" v-else-if="localContent && localContent.length > 3">
      <VueAgile
        :options="options"
        :ref="uniqueId"
      >
        <div
          v-for="(c, index) in localContent"
          :key="index"
          :class="`slide--${index}`"
          class="slide"
        >
          <PostThumbCard
            v-if="c && c.type === 'post'"
            :post="c.entity"
            @post-destroyed="destroyContent"
          />
          <UserProfileCard
            v-if="c && c.type === 'user'"
            :user="c.entity"
          />
          <BookThumbCard
            v-if="c && c.type === 'book'"
            :book="c.entity"
            @book-destroyed="destroyContent"
          />
        </div>
        <template slot="prevButton"><i class="fa fa-angle-left"></i></template>
        <template slot="nextButton"><i class="fa fa-angle-right"></i></template>
      </VueAgile>
    </div>
  </div>
</template>

<script>

import { createUniqueId } from '@/utils'

import PostThumbCard from '@/components/post/PostThumbCard.vue'
import BookThumbCard from '@/components/books/BookThumbCard.vue'
import UserProfileCard from '@/components/user/UserProfileCard.vue'

import { VueAgile } from 'vue-agile'

export default {
  name: 'ListThumbCarousel',
  props: ['content'],
  components: {
    PostThumbCard,
    BookThumbCard,
    UserProfileCard,
    VueAgile
  },
  data () {
    return {
      localContent: [],
      options: {
        dots: false,
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              dots: true
            }
          }
        ]
      }
    }
  },
  watch: {
    content (newContent, oldContent) {
      this.localContent = [...newContent]
    }
  },
  computed: {
    uniqueId () {
      return `carousel-${createUniqueId()}`
    }
  },
  created () {
    this.localContent = [...this.content]
  },
  methods: {
    destroyContent (id) {
      const index = this.localContent.findIndex(c => c.entity.id === id)
      this.localContent.splice(index, 1)
      if (this.$refs[this.uniqueId]) this.$refs[this.uniqueId].reload()
    }
  }
}
</script>

<style lang="scss">
/* POSTS THUMB CAROUSEL */
.post-thumbs-carousel {
  .agile__nav-button {
    position: absolute;
    top: calc(50% - 15px);
    background: transparent;
    padding: 0;
    border: none;

    @include tablet {
      top: calc(50% - 30px);
    }

    i {
      color: $color2;
      font-size: 30px;

      @include tablet {
        font-size: 50px;
      }
    }
  }

  .agile__nav-button--prev {
    left: -10px;

    @include tablet {
      left: -25px;
    }
  }

  .agile__nav-button--next {
    right: -10px;

    @include tablet {
      right: -25px;
    }
  }

  .agile__slide {
    padding: 10px;
  }

  .agile__dots{
    margin: 10px auto;

    @include tablet {
      position: absolute;
      top: -44px;
      right: 0;
    }

    .agile__dot{
      margin: 0 10px;
      button{
        background-color: #ddd;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: block;
        height: 10px;
        font-size: 0;
        line-height: 0;
        margin: 0;
        padding: 0;
        transition-duration: .3s;
        width: 10px;
      }

      &--current,&:hover{
        button{
          background-color: $color2;
        }
      }
    }
  }
}
</style>
